<div class="py-4 d-flex flex-column" style="height: 461px;">
    <div class="subtitle-1 lato-bold">{{header}}</div>
    <div class="content mx-3 my-4 d-flex flex-wrap flex-fill" style="overflow: auto" 
        [ngStyle]="{'width': 'calc(' + viewSettings.columns + 'px * ' + viewSettings.badgeSize + ' + (' + viewSettings.columns + ' * 8px) + 17px)',
        'height': 'calc(' + viewSettings.rows + 'px * ' + viewSettings.badgeSize + ' + (' + viewSettings.rows + ' * 8px))'}">
        <div *ngIf="showCustomBadge" class="cvBadgeSelectorImage m-1" (click)="openCustomBadgeDialog()">
            <div class="rounded-circle ml-2 mt-2 w-75 h-75 position-relative" style="background-color: #E0E3E6;">
                <div class="position-absolute" style="left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <svg class="icon-24 fill-cerulean"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                </div>
            </div>
        </div>
        <div class="cvBadgeSelectorImage m-1" *ngFor="let badgeID of bss.badges" (click)="selectBadge(badgeID)" [ngClass]="selectedBadge == badgeID ? 'selected' : ''">
            <img [src]="'../Admin/ImageResizer.aspx?imgid=' + badgeID + '&w=70&h=70'" />
        </div>
    </div>
    <div class="d-flex">
        <div class="flex-fill"></div>
        <button type="button" class="btn btn-text" (click)="close()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="selectAndClose()" cvLocalizedText langSection="Import_Data" langKey="Select">Select</button>
    </div>

    <cv-custom-badge-creator [hidden]="!customBadgeCreatorVisible" [badgeType]="'award'"
        [showWhen]="customBadgeCreatorVisible" (onCancel)="close()" (onSave)="customBadgeSaved($event)">
    </cv-custom-badge-creator>
</div>